import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../component/common/Button";
import Input from "../../../component/common/Input";
import { useUser } from "../../../context/UserContext";
import { useFormContext } from "react-hook-form";

const ForIndividual = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();
  const {
    register,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    clearErrors();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-white p-[20px] sm:p-10">
      <div className="card w-[926px] p-[20px] sm:p-[40px]">
        <h1 className="heading">Register as Individual</h1>
        <p className="paragraph">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis morbi
          pulvinar venenatis non.
        </p>

        <div className="space-y-6">
          <div className="flex flex-col sm:flex-row sm:gap-3 w-full">
            <div className="w-full sm:w-[48%]">
              <Input
                label={"Full Name"}
                placeholder={"Your Full name"}
                {...register("name", { required: "Full Name is required" })} // Register input
              />
              {errors.name && (
                <span className="text-red-500 text-sm">
                  {errors.name.message}
                </span>
              )}
            </div>
            <div className="w-full sm:w-[48%]">
              <Input
                label={"Email"}
                placeholder={"Your Email ID"}
                {...register("email", { required: "Email is required" })} // Register input
              />
              {errors.email && (
                <span className="text-red-500 text-sm">
                  {errors.email.message}
                </span>
              )}
            </div>
            {/* <div className="w-full sm:w-[48%]">
              <Input
                label={"Job Title"}
                placeholder={"Enter Job Title"}
                {...register("jobTitle", { required: "Job Title is required" })} // Register input
              />
              {errors.jobTitle && (
                <span className="text-red-500 text-sm">
                  {errors.jobTitle.message}
                </span>
              )}
            </div> */}
          </div>
          <div className="flex flex-col sm:flex-row sm:gap-3 w-full">
            <div className="w-full sm:w-[48%]">
              <Input
                label={"Mobile"}
                placeholder={"Your mobile number"}
                {...register("phoneNumber", {
                  required: "Mobile number is required",
                })} // Register input
              />
              {errors.phoneNumber && (
                <span className="text-red-500 text-sm">
                  {errors.phoneNumber.message}
                </span>
              )}
            </div>
            <div className="w-full sm:w-[48%]">
              <Input
                label={"Location"}
                placeholder={"Your Location"}
                {...register("location", { required: "Location is required" })} // Register input
              />
              {errors.location && (
                <span className="text-red-500 text-sm">
                  {errors.location.message}
                </span>
              )}
            </div>
          </div>
          <div className="space-y-4 w-full">
            <div className="flex flex-col sm:flex-row sm:gap-3 w-full">
              {/* Description textarea */}
              <div className="relative flex flex-col w-full sm:w-1/2">
                <label className="mb-2 text-[12px] font-medium text-black block">
                  Description
                </label>
                <textarea
                  placeholder={"Put description of up to 50 - 500 Characters"}
                  className="pr-4 pl-5 py-3 text-black rounded bg-white w-full placeholder:text-500-gray text-sm focus:outline-none h-[77px]"
                  {...register("description", {
                    required: "Description is required",
                  })}
                />
                {errors.description && (
                  <span className="text-red-500 text-sm">
                    {errors.description.message}
                  </span>
                )}
              </div>

              {/* Business Hub Name input */}
              <div className="relative flex flex-col w-full sm:w-1/2">
                <Input
                  label={"Business Hub Name"}
                  placeholder={"Your Business hub name"}
                  {...register("businessHubName")}
                />
                {errors.businessHubName && (
                  <span className="text-red-500 text-sm">
                    {errors.businessHubName.message}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="space-y-1 gap-3 flex-col sm:flex-row w-full flex items-center justify-between"></div>
        </div>
        <div className="flex justify-center w-full">
          <Button
            content="Sign Up"
            classes="mt-[41px] sm:w-[50%] w-full text-sm sm:text-base hover:bg-[#3872A5] duration-300 justify-center"
            type="submit"
          />
        </div>
      </div>
    </div>
  );
};

export default ForIndividual;
